<script lang="ts">
    import { mealyMachine_Ampelsystem_pauseTimer, mealyMachine_Ampelsystem_resumeTimer, mealyMachine_Ampelsystem_setTimer, mealyMachine_Ampelsystem_startTimer, mealyMachine_Ampelsystem_stopTimer, mealyMachine_executeSingleStep } from "../../actions/machine";

    import { getUpdateMachineState } from '../../mealy/context';

    export let machineState: MachineStateMealy_AmpelSystem;
    export let mealyExecutionState: MealyExecutionState;
    export let isExecuting: boolean;
    
    import { onMount, onDestroy } from 'svelte';
    import ManRed from './ManRed.svelte';
    import ManGreen from './ManGreen.svelte';
    import Timer from "./Timer.svelte";
    import Anforderungstaster from "./Anforderungstaster.svelte";
    import type { MachineStateMealy_AmpelSystem } from "../../state/machineState";
    import type { MealyExecutionState } from "../../state/executionState";
    import { EditMode } from "../../state/uiState";

    // --------------------------------------------------------------------------------
    // Systick 
    let systickTimerId = 0;

    onMount( () => {
        systickTimerId = window.setInterval(handleSystick, 50);
    });

    onDestroy( () => {
        window.clearInterval(systickTimerId);
    });

    function handleSystick() {
        const timer = machineState.ampelSystemState.timer;
        if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION && machineState.ampelSystemState.timer.state === 'running') {
            // Timer pausieren
            updateMachineState(mealyMachine_Ampelsystem_pauseTimer(machineState));
        }
        else if (machineState.uiState.editMode === EditMode.EXECUTION && machineState.ampelSystemState.timer.state === 'paused') {
            // Timer weiterlaufen lassen
            updateMachineState(mealyMachine_Ampelsystem_resumeTimer(machineState, performance.now()));
        } else if (machineState.uiState.editMode === EditMode.EXECUTION && machineState.ampelSystemState.timer.state === 'running') {
            // Timer läuft
            const now = performance.now();
            // console.log('now', now);

            // neuen Value berechnen
            const deltaTimerValue = now - timer.lastResumeTimestamp;
            const newTimerValue = timer.lastResumeValue - deltaTimerValue;
            // console.log('newTimerValue', newTimerValue);

            if (newTimerValue > 0) {
                updateMachineState(mealyMachine_Ampelsystem_setTimer(machineState, true, newTimerValue));
            } else {
                const newMachineState = mealyMachine_Ampelsystem_stopTimer(machineState, 0);
                executeStep('Timer', newMachineState);
            }

        }
    }
    // --------------------------------------------------------------------------------

    const updateMachineState = getUpdateMachineState();

    function executeStep(inputChar: string, machineState: MachineStateMealy_AmpelSystem) {
        const [newMachineState, stepHasBeenExecuted] = mealyMachine_executeSingleStep(machineState, inputChar);
        if (stepHasBeenExecuted) {
            if (newMachineState.executionState.lastTransitionOutput === 'rot_Timer' || newMachineState.executionState.lastTransitionOutput === 'grün_Timer') {
                updateMachineState(mealyMachine_Ampelsystem_startTimer(newMachineState, performance.now(), 5000));
                return;
            }
        }

        updateMachineState(newMachineState);
    }

    $: showRed = (() => {
        if (isExecuting && mealyExecutionState.lastTransitionOutput) {
            if (mealyExecutionState.lastTransitionOutput === 'rot' || mealyExecutionState.lastTransitionOutput === 'rot_Timer') {
                return true;
            } else {
                return false;
            }
        }
        else {
            return true;
        }
    })();

    $: showGreen = (() => {
        if (isExecuting && mealyExecutionState.lastTransitionOutput) {
            if (mealyExecutionState.lastTransitionOutput === 'grün' || mealyExecutionState.lastTransitionOutput === 'grün_Timer') {
                return true;
            } else {
                return false;
            }
        }
        else {
            return false;
        }
    })();

    function handleTasterClick() {
        if (isExecuting) {
            executeStep('Taster', machineState);
        }
    }
</script>

<svg viewBox="0 0 200 250" width="200px" height="250px">
    <g transform="translate(35 0)">
        <rect x="0" y="0" width="50" height="100" fill="lightgrey"/>
        <circle cx="25" cy="25" r="20" fill="grey" />
        <circle cx="25" cy="75" r="20" fill="grey" />
        
        {#if showRed}
            <g transform = "translate(25 25) scale(0.32)">
                <ManRed />
            </g>
        {/if}

        {#if showGreen}
            <g transform = "translate(25 75) scale(0.32)">
                <ManGreen />
            </g>
        {/if}
    </g>
    <foreignObject x="35" y="125" width="80" height="130">
            <button class="buttonAmpel" on:click={handleTasterClick}><Anforderungstaster /></button>
    </foreignObject>

    <g transform="translate(100 10)">
        <Timer value={Math.floor(machineState.ampelSystemState.timer.value / 1000)} />
    </g>

    <!-- <g transform="translate(35 110)">
        <Anforderungstaster />
    </g> -->
</svg>

<style>
    .buttonAmpel {
        background-color: #fae825;
        border-radius : 10px 10px 10px 10px;
        border: none;
    
        padding: 0;
        margin: 0;
        box-shadow: none;
        transition: none;
    }

    .buttonAmpel:active {
        background-color: #e3d219;
    }
</style>